// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SchedulerListResultModel from '../../model/scheduler-list-result-model';
import SchedulerListResultDTO from '../dto/scheduler-list-result-dto';
import dtoSchema from '../schemas/scheduler-list-result-schema';
import SchedulerModel from '../../model/scheduler-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SchedulerListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SchedulerListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SchedulerModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SchedulerModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SchedulerListResultDTO>): SchedulerListResultModel;
  static toModel(dto: DeepPartial<SchedulerListResultDTO> | undefined | null): SchedulerListResultModel | undefined;
  static toModel(dto: DeepPartial<SchedulerListResultDTO> | undefined | null): SchedulerListResultModel | undefined {
    return dto ? new SchedulerListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SchedulerListResultModel> | SchedulerListResultModel): SchedulerListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SchedulerListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SchedulerListResultModel, can not map to SchedulerListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
